import { Card, CardBody, CardTitle, CardSubtitle, Table } from "reactstrap";
import PropTypes from 'prop-types';
import React from "react";

const PaymentTable = ({ title, tableData, toggledRows, setToggledRows }) => {
  const handleToggleClick = (rowKey) => {
    setToggledRows((prev) =>
      prev.includes(rowKey)
        ? prev.filter((k) => k !== rowKey)
        : [...prev, rowKey]
    );
  };
  return (
    <div>
      <Card style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
        <CardBody>
          <CardTitle tag="h5">{title}</CardTitle>
          <CardSubtitle className="mb-2 text-muted" tag="h6">
            Vista general
          </CardSubtitle>

          <Table className="no-wrap mt-3 align-middle" responsive borderless size="sm">
            <thead>
              <tr>
                  <th>Concepto</th>
                  <th className="text-center">Fecha</th>
                  <th>Total</th>
                  <th className="text-center">Referencia</th>
                  <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
                {tableData.length === 0 ? (
                  <div className="text-center text-gray-500">No hay pagos disponibles.</div>
                ) : (
                  tableData.map((tdata, idx) => {
                    let statusIndicator;
                    let statusText;
                    if (tdata.status === 2) {
                      statusIndicator = <span className="p-2 bg-danger rounded-circle d-inline-block ms-3"></span>;
                      statusText = 'Pendiente';
                    } else if (tdata.status === 0) {
                      statusIndicator = <span className="p-2 bg-warning rounded-circle d-inline-block ms-3"></span>;
                      statusText = 'En Proceso';
                    } else {
                      statusIndicator = <span className="p-2 bg-success rounded-circle d-inline-block ms-3"></span>;
                      statusText = 'Pagado';
                    }
                    // Use id if present and unique, else fallback to index
                    const key = tdata.id ? `row-${tdata.id}` : `row-${idx}`;
                    return (
                      <tr key={key} className="border-top">
                        <td>
                          <div className="d-flex align-items-center p-0">
                            <div className="ms-3">
                              <span className="text-muted">{tdata.category}</span>
                            </div>
                          </div>
                        </td>
                        <td className="text-center">{tdata.createdDate}</td>
                        <td>
                          {tdata.balance}
                          {tdata.status === 2 && (
                            toggledRows.includes(key) ? (
                              <button
                                type="button"
                                onClick={() => handleToggleClick(key)}
                                className="inline-flex items-center justify-center rounded-full w-6 h-6 ml-2 bg-red-500 cursor-pointer hover:bg-red-600 transition-colors focus:outline-none"
                                aria-label="Quitar"
                              >
                                <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                                  <path d="M4 10h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={() => handleToggleClick(key)}
                                className="inline-flex items-center justify-center rounded-full w-6 h-6 ml-2 bg-blue-500 cursor-pointer hover:bg-blue-600 transition-colors focus:outline-none"
                                aria-label="Agregar"
                              >
                                <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                                  <path d="M10 4v12M4 10h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                              </button>
                            )
                          )}
                        </td>
                        <td className="text-center">
                          <span className="text-muted">{tdata.referenceNumber}</span>
                        </td>
                        <td>
                          {statusIndicator} <span className="text-muted">{statusText}</span>
                        </td>
                      </tr>
                    );
                  })
                )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

PaymentTable.propTypes = {
  title: PropTypes.string.isRequired,
  tableData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status: PropTypes.number,
    category: PropTypes.string,
    createdDate: PropTypes.string,
    balance: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  toggledRows: PropTypes.array.isRequired,
  setToggledRows: PropTypes.func.isRequired
};

export default PaymentTable;
